// src/components/Tracking/PageVisitTracker.jsx
import usePageVisitTracker from "../../hooks/usePageVisitTracker";

export default function PageVisitTracker() {
  usePageVisitTracker();
  return null;
}